import request from '@/utils/request'

// 门票接口：

// 新增景区：post ticket/createSpot, 参数：
// title // 标题
// avatar // 封面
// imageList // 轮播图
// text // 图文说明
// lat // 纬度
// lng // 经度
// order // 排序
export function createSpot(data) {
    return request({
      url: '/spot/create',
      method: 'post',
      data,
    })
  }
// 修改景区：post ticket/updateSpot, 参数：
// spotId // 景区ID
// title // 标题
// avatar // 封面
// imageList // 轮播图
// text // 图文说明
// lat // 纬度
// lng // 经度
// order // 排序
export function updateSpot(data) {
    return request({
      url: '/spot/update',
      method: 'post',
      data,
    })
  }
// 删除景区：post ticket/removeSpot, 参数：
// spotId // 景区ID
export function removeSpot(data) {
    return request({
      url: '/spot/remove',
      method: 'post',
      data,
    })
  }
// 获取单个景区：get ticket/findSpot, 参数：
// spotId // 景区ID
export function findSpot(params) {
    return request({
      url: '/spot/find',
      method: 'get',
      params,
    })
  }
// 获取景区列表：get ticket/findSpotList, 参数：
// page
// size
// keyword // 关键词，标题/图文说明
export function findSpotList(params) {
    return request({
      url: '/spot/findList',
      method: 'get',
      params,
    })
  }
// 获取所有景区：get ticket/findSpotAll, 参数：
// keyword // 关键词，标题/图文说明
export function findSpotAll(params) {
    return request({
      url: '/spot/findAll',
      method: 'get',
      params,
    })
  }
// 新增门票标签：post ticket/createTag, 参数：
// title // 标题
// icon // 图标
// order // 排序
export function createTag(data) {
    return request({
      url: '/spot/createTag',
      method: 'post',
      data,
    })
  }
// 修改门票标签：post ticket/updateTag, 参数：
// tagId // 标签ID
// title // 标题
// icon // 图标
// order // 排序
export function updateTag(data) {
    return request({
      url: '/spot/updateTag',
      method: 'post',
      data,
    })
  }
// 删除门票标签：post ticket/removeTag, 参数：
// tagId // 标签ID
export function removeTag(data) {
    return request({
      url: '/spot/removeTag',
      method: 'post',
      data,
    })
  }
// 获取单个门票标签：get ticket/findTag, 参数：
// tagId // 标签ID
export function findTag(params) {
    return request({
      url: '/spot/findTag',
      method: 'get',
      params,
    })
  }
// 获取门票标签列表：get ticket/findTagList, 参数：
// page
// size
// keyword // 关键词，标题
export function findTagList(params) {
    return request({
      url: '/spot/findTagList',
      method: 'get',
      params,
    })
  }
// 获取所有门票标签：get ticket/findTagAll, 参数：
// keyword // 关键词，标题
export function findTagAll(params) {
    return request({
      url: '/spot/findTagAll',
      method: 'get',
      params,
    })
  }
// 新增门票：post ticket/create, 参数：
// title // 标题
// typehood // 类型，1：日票，2：期票，3：年卡
// defaultPrice // 默认价格
// datePriceList // 特殊日期价格，[{startDate//开始日期MM-DD, endDate//结束日期MM-DD, price//价格}]
// weekPriceList // 特殊星期价格，[{startMonth//开始月份MM，endMonth//结束月份MM, WeekList//星期列表[d,], price//价格}]
// defaultStock // 默认日库存
// dateStockList // 特殊日期库存，[{startDate//开始日期MM-DD, endDate//结束日期MM-DD, stock//日库存}]
// weekStockList // 特殊星期库存，[{startMonth//开始月份MM，endMonth//结束月份MM, WeekList//星期列表[d,], stock//日库存}] 
// text // 图文说明
// note // 购票须知
// tagIdList // 标签列表
// order // 排序
export function create(data) {
    return request({
      url: '/spot/createTicket',
      method: 'post',
      data,
    })
  }
// 修改门票：post ticket/update, 参数：
// ticketId // 门票ID
// title // 标题
// typehood // 类型，1：日票，2：期票，3：年卡
// defaultPrice // 默认价格
// datePriceList // 特殊日期价格，[{startDate//开始日期MM-DD, endDate//结束日期MM-DD, price//价格}]
// weekPriceList // 特殊星期价格，[{startMonth//开始月份MM，endMonth//结束月份MM, WeekList//星期列表[d,], price//价格}]
// defaultStock // 默认日库存
// dateStockList // 特殊日期库存，[{startDate//开始日期MM-DD, endDate//结束日期MM-DD, stock//日库存}]
// weekStockList // 特殊星期库存，[{startMonth//开始月份MM，endMonth//结束月份MM, WeekList//星期列表[d,], stock//日库存}] 
// text // 图文说明
// note // 购票须知
// tagIdList // 标签列表
// order // 排序
export function update(data) {
    return request({
      url: '/spot/updateTicket',
      method: 'post',
      data,
    })
  }
// 删除门票：post ticket/remove, 参数：
// ticketId // 门票ID
export function remove(data) {
    return request({
      url: '/spot/removeTicket',
      method: 'post',
      data,
    })
  }
// 获取单个门票：get ticket/find, 参数：
// ticketId // 门票ID
export function find(params) {
    return request({
      url: '/spot/findTicket',
      method: 'get',
      params,
    })
  }
// 获取门票列表：get ticket/findList, 参数：
// page
// size
// keyword // 关键词，标题
export function findList(params) {
    return request({
      url: '/spot/findTicketList',
      method: 'get',
      params,
    })
  }
// 获取所有门票：get ticket/findAll, 参数：
// keyword // 关键词，标题
export function findAll(params) {
    return request({
      url: '/spot/findTicketAll',
      method: 'get',
      params,
    })
  }
// 提交订单：post ticket/createOrder, 参数：
// spotId // 景区ID
// ticketList // 购票列表,[{ticketId, count}]
// visitList // 游客列表[{name//姓名,tel//手机号,identityId//身份证号}]
// contact // 联系人信息{name//姓名,tel//手机号}
// text // 订单备注
export function createOrder(data) {
    return request({
      url: '/spot/createOrder',
      method: 'post',
      data,
    })
  }
// 核销订单：post ticket/finishOrder, 参数：
// orderId // 订单ID
// ticketList // 核销票列表,[{ticketId,count}]
export function finishOrder(data) {
    return request({
      url: '/spot/finishOrder',
      method: 'post',
      data,
    })
  }
// 订单退款：post ticket/refundOrder, 参数：
// orderId // 订单ID
// refundAmount // 退款金额
// ticketList // 退票列表,[{ticketId,count}]
export function refundOrder(data) {
    return request({
      url: '/spot/refundOrder',
      method: 'post',
      data,
    })
  }
// 取消订单：post ticket/cancelOrder, 参数：
// orderId // 订单ID
export function cancelOrder(data) {
    return request({
      url: '/spot/cancelOrder',
      method: 'post',
      data,
    })
  }
// 获取单个订单：post ticket/findOrder, 参数：
// orderId // 订单ID
export function findOrder(params) {
    return request({
      url: '/spot/findOrder',
      method: 'get',
      params,
    })
  }
// 获取订单列表：post ticket/findOrderList, 参数：
// page
// size
// step // 订单状态
// startDate // 开始日期
// endDate // 结束日期
// keyword // 关键词，订单号/订单标题/姓名/手机号
export function findOrderList(params) {
    return request({
      url: '/spot/findOrderList',
      method: 'get',
      params,
    })
  }
// 获取我的订单列表：post ticket/findMyOrderList, 参数：
// page
// size
// step // 订单状态
// startDate // 开始日期
// endDate // 结束日期
// keyword // 关键词，订单号/订单标题/姓名/手机号
export function findMyOrderList(params) {
    return request({
      url: '/spot/findMyOrderList',
      method: 'get',
      params,
    })
  }
// 导出订单：get ticket/exportOrder, 参数：
// startDate // 开始日期
// endDate // 结束日期
// keyword // 关键词，订单号/订单标题/姓名/手机号
export function exportOrder(params) {
  return request({
    url: '/spot/exportOrder',
    method: 'get',
    params,
  })
}

// 新增常见问题
export function createFaq(data) {
  return request({
    url: '/spot/createFaq',
    method: 'post',
    data,
  })
}

// 修改常见问题
export function editFaq(data) {
  return request({
    url: '/spot/updateFaq',
    method: 'post',
    data,
  })
}

// 删除常见问题
export function delFaq(data) {
  return request({
    url: '/spot/removeFaq',
    method: 'post',
    data,
  })
}

// 获取常见问题列表
export function getFaqList(params) {
  return request({
    url: '/spot/findFaqList',
    method: 'get',
    params,
  })
}

// 获取单个常见问题
export function getFaq(params) {
  return request({
    url: '/spot/findFaq',
    method: 'get',
    params,
  })
}

// 获取所有常见问题
export function getFaqAll(params) {
  return request({
    url: '/spot/findFaqAll',
    method: 'get',
    params,
  })
}